export class CostsPerEmployeeType {
    
    id: number = 0;
    code!: string;
    description!: string;
    
}